module.exports = __webpack_public_path__ + "img/guide.51c4f5f3.png";